import { TimeFormat, TimeOfDayValue } from "@/types/time";
import { CtaStyle } from "../Button/types";

export const DEFAULT_TIME = "08:00";

export interface BusinessHourTime {
  start: string;
  end: string;
}

export interface BusinessHoursDay {
  enabled: boolean;
  times: BusinessHourTime[];
}

export type BusinessHoursDays = {
  monday: BusinessHoursDay;
  tuesday: BusinessHoursDay;
  wednesday: BusinessHoursDay;
  thursday: BusinessHoursDay;
  friday: BusinessHoursDay;
  saturday: BusinessHoursDay;
  sunday: BusinessHoursDay;
};

export const BUSINESS_HOURS_DAY_KEYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
] as const satisfies ReadonlyArray<keyof BusinessHoursDays>;

export interface BusinessHours {
  format: TimeFormat;
  days: BusinessHoursDays;
}

export interface BusinessHourProps {
  defaultValue: BusinessHours;
  onClick?: (hours: BusinessHours) => void;
  ctaStyle?: CtaStyle;
}

export type DayKey = keyof BusinessHoursDays;

export type BusinessHoursViewProps = {
  ctaStyle?: CtaStyle;
  timeFormat: TimeFormat;
  days: BusinessHoursDays;
  onTimeFormatChange: (format: TimeFormat) => void;
  onDayEnabledChange: (day: DayKey, enabled: boolean) => void;
  onAddTimeSlot: (day: DayKey) => void;
  onRemoveTimeSlot: (day: DayKey, timeIndex: number) => void;
  onTimeChange: (
    day: DayKey,
    timeIndex: number,
    timeSlot: "start" | "end",
    time?: TimeOfDayValue
  ) => void;
};

export type TimeRowProps = {
  day: DayKey;
  timeIndex: number;
  timeFormat: TimeFormat;
  isEnabled: boolean;
  value?: BusinessHourTime;
  fromLabel: string;
  toLabel: string;
  onAddTimeSlot: (day: DayKey) => void;
  onRemoveTimeSlot: (day: DayKey, timeIndex: number) => void;
  onTimeChange: (
    day: DayKey,
    timeIndex: number,
    timeSlot: "start" | "end",
    time?: TimeOfDayValue
  ) => void;
};
